import React, { useState } from 'react'
import Toast from 'react-bootstrap/Toast'
import styles from './loader.module.css';

const mystyle = {
  position: 'absolute',
  top: '30%',
  left: '35%',
  right: '0'
};

export const Toaster = ({ errors_list, error_state }) => {  // errors_list - to read errors, error_state - to clear errors callback
  const [show, setShow] = useState(true);

  if (errors_list === undefined) {
    return <p className="alert alert-danger">Some critical error appear..</p>
  }

  return (
    <div className={styles.loader}>
      <Toast style={mystyle} onClose={() => { setShow(false); error_state(false) }} show={show} delay={5000} animation={true} autohide={false}>
        <Toast.Header >
          <strong className="mr-auto text-danger">Error Message</strong>
        </Toast.Header>
        {errors_list &&
          <Toast.Body className="alert alert-danger">
            {
              Array.isArray(errors_list) ?
                (errors_list.map((m, idx) => <div key={idx}>{JSON.stringify(m)}</div>))
                : JSON.stringify(errors_list)
            }
          </Toast.Body>
        }
      </Toast>
    </div>

  )
}



// class Toaster extends Component {
//   render() {
//     return (
//       <div className="alert alert-danger"><span>Toaster Here</span></div>
//     );
//   }
// }
//
// export default Toaster;
